export const getCatalogPageQuery = (
  currentQuery: Record<string, string | string[] | number | undefined>,
  nextPage: number
) => {
  const { page: _page, ...rest } = currentQuery;

  if (nextPage <= 1) {
    return rest;
  }

  return {
    ...rest,
    page: String(nextPage),
  };
};

export const getCatalogListingHref = (asPath: string, nextPage: number) => {
  const pathOnly = asPath.split('?')[0];

  if (nextPage <= 1) {
    return pathOnly;
  }

  return `${pathOnly}?page=${nextPage}`;
};
